import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography,Divider} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import StitchingtaskInfo from '../StitchingtaskInfo';
import IconEnabled from 'core/components/layout/IconEnabled';
import { convertToRS } from 'core/js/FormUtils';
import StitchingtaskFilterCriteria from '../StitchingtaskFilterCriteria';
import StitchingtaskDashboard from '../StitchingtaskDashboard';


export default function StitchingtaskListTableRow({obj, getActionComponent,actionList,handleRowClick}){
  const {UpdateStatusModalOpen} = useSelector((state) => state.manufslice.taskinstanceDashboard);
  const {mobileView} = useSelector((state) => state.menu);
  
  useEffect(()=>{
  },[])
  const getHoverColor = () =>{
    if (mobileView) return ''
    return 'primary.main';
  }
  const getHoverBackgroundColor = () =>{
    if (mobileView) return ''
    return 'secondary.200';
  }
  const getBackgroundColor = (obj) =>{
    if (mobileView) {
      if (obj.expand) return 'secondary.500'
      return 'white'
    }
    return 'white'
  }
    return (
      
      <>
        <Grid item lg={12} sx={{ width: '100%'}}>
          {/* <ROW1 - CONTAINER/> */}
          <Grid container direction="row" onClick={() => handleRowClick(obj.id)}
            sx={{
              //cursor: 'pointer',
              justifyContent: "flex-start", alignItems: "center",  padding:1,  
              backgroundColor: getBackgroundColor(obj),
              color: mobileView && obj.expand?'primary.main':'primary.darker',
              '&:hover': {
                backgroundColor: getHoverBackgroundColor, 
                color: getHoverColor()
              },
            }}>
            {UpdateStatusModalOpen? <>
            
              <Grid item lg={4} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.workername}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.assignedqty}</Typography></Grid>
               <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{convertToRS(obj.earning)}</Typography></Grid>
              <Grid item lg={2} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.receivedqty}</Typography></Grid>
              

              </>:<>
              <Grid item lg={1} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderid}</Typography></Grid>
              <Grid item lg={1} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.orderid==0?obj.productorderid:''}</Typography></Grid>
              <Grid item lg={2} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.productname}</Typography></Grid>
              <Grid item lg={2} xs={6} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.workername}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.assignedqty}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.receivedqty}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{convertToRS(obj.stitchingrate)}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{convertToRS(obj.earning)}</Typography></Grid>
              <Grid item lg={1} xs={2} ><Typography color="" sx={{ fontWeight: 'light', fontSize: 15 }}>{obj.taskstatusname}</Typography></Grid>
              </>
            }
              
              <Grid item lg={UpdateStatusModalOpen?2:1} xs={2} >
                <Grid container direction="row" sx={{ justifyContent: "flex-end", width: '100%', }}>
                  { UpdateStatusModalOpen && obj.taskstatusname && obj.taskstatusname === 'TODO' ? <>
                  <IconEnabled key={`${obj.id}-${actionList[0].title}`} actionObj={actionList[0]} id={obj.id} />
                  <IconEnabled key={`${obj.id}-${actionList[1].title}`} actionObj={actionList[1]} id={obj.id} />
                  </>:
                  <>
                  <IconEnabled key={`${obj.id}-${actionList[3].title}`} actionObj={actionList[3]} id={obj.id} />
                  {obj.taskstatusname && obj.taskstatusname !== 'DONE' && (
                    <IconEnabled key={`${obj.id}-${actionList[4].title}`} actionObj={actionList[4]} id={obj.id} />
                  )}
                  </>
                  }
                </Grid>
              </Grid>
            
          </Grid>
        </Grid>
        <Grid item lg={12} sx={{ width: '100%' }}> <Divider /></Grid>
        {/* {obj.expand ?
        <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            < StitchingtaskInfo  stitchingtaskObj={obj} />
          </Grid>
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>
        : <Grid container direction="row">
          <Grid item sx={{ width: '100%' }}>
            <Divider />
          </Grid>
        </Grid>} */}
      </>
      
    )
}